export default "__VITE_ASSET__a0aa0483__"